module.exports = __webpack_public_path__ + "img/ST.abae1833.png";